import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ko from './locales/ko.json'

// Detect browser language, fallback to 'en'
function getDefaultLocale() {
    const stored = localStorage.getItem('xoul-locale')
    if (stored) return stored

    const browserLang = navigator.language || navigator.userLanguage || 'en'
    if (browserLang.startsWith('ko')) return 'ko'
    return 'en'
}

const i18n = createI18n({
    legacy: false,
    locale: getDefaultLocale(),
    fallbackLocale: 'en',
    messages: { en, ko },
})

export default i18n
